import { Map, Record } from 'immutable';

import { GroupingTagItemEntity } from '../domain/grouping-tag-item.entity';

export const GroupingTagSliceKey = 'main';

export interface IGroupingTagMainSliceState {
	loading: boolean;
	groupingTags: Map<string, GroupingTagItemEntity>;
	totalItems: number;
}

export const defaults: IGroupingTagMainSliceState = {
	loading: false,
	groupingTags: Map(),
	totalItems: 0,
};

export class GroupingTagMainSliceState extends Record<IGroupingTagMainSliceState>(
	defaults
) {
	public static readonly key = GroupingTagSliceKey;

	public setLoading(isLoading: boolean): GroupingTagMainSliceState {
		return this.set('loading', isLoading);
	}

	public setSubscriptions(
		elements: Map<string, GroupingTagItemEntity>
	): GroupingTagMainSliceState {
		return this.set('groupingTags', elements);
	}

	public setTotalItems(total: number): GroupingTagMainSliceState {
		return this.set('totalItems', total);
	}
}
